/*
      auto generated  Wednesday, August 5, 2026 16:33:12 PM
      script          /make.php
      do not modify - changes do not persist
*/
const data={
MQ:["DO NOT USE MQ[0]","DO NOT USE MQ[1]",222,333,444,555,666,777,888,999],
FS:["DO NOT USE FS[0]",24,23,22,21,20,19,18,17,16,"DO NOT USE FS[10]",15,14,13,12,11,10,10,10,10,"DO NOT USE FS[20]",10,10,10,10,10,10,10,10,10],
PFS:["DO NOT USE PFS[0]",20,19,18,17,16,15,14,13,12,"DO NOT USE PFS[10]",11,10,9,8,8,8,8,8,8,"DO NOT USE PFS[20]",8,8,8,8,8,8,8,8,8],
HFS:["DO NOT USE HFS[0]",20,19,18,17,16,15,14,13,12,"DO NOT USE HFS[10]",11,10,9,8,8,8,8,8,8,"DO NOT USE HFS[20]",8,8,8,8,8,8,8,8,8],
EFS:["DO NOT USE EFS[0]",20,19,18,17,16,15,14,13,12,"DO NOT USE EFS[10]",11,10,9,8,8,8,8,8,8,"DO NOT USE EFS[20]",8,8,8,8,8,8,8,8,8],
IFS:["DO NOT USE IFS[0]",18,17,16,15,14,13,12,11,10,"DO NOT USE IFS[10]",9,9,9,8,8,8,8,8,8,"DO NOT USE IFS[20]",8,8,8,8,8,8,8,8,8],
BACKGROUND_THEME:'#606040',
THEME:'#006040',
COLOR_RED:'#cc0000',
COLOR_THEME:'#006040',
MASTER_ANIMATION_LENGTH:1,
LOGO_CLOCKWISE_ANIMATION_LENGTH:8,
LOGO_ANTI_CLOCKWISE_ANIMATION_LENGTH:19,
LTR_PLACEHOLDER_FONT:'20px "Helvetica Neue", Helvetica, Arial, sans-serif',
RTL_PLACEHOLDER_FONT:'20px "Noto Naskh Arabic UI", "Noto Sans UI", "Helvetica Neue", Helvetica, Arial, sans-serif',
COLOR_ERROR:'red',
COLOR_HELP:'#999',
COLOR_FIELDSET_BORDER:'1px solid #aaa',
COLOR_BOX_BORDER:'1px solid #ddd',
COLOR_PLACEHOLDER:'gray',
MOBILE_MAX_WIDTH:111,
HEIGHT:48,
WIDTH:170,
LOGO_HEIGHT:48,
SLIDE_SMALL_WIDTH:'69%',
SLIDE_LARGE_WIDTH:'90%',
SLIDE_SMALL_HEIGHT:48,
SLIDE_LARGE_HEIGHT:144,
FACE_HEIGHT:32,
OPTION_HEIGHT:32,
GROUP_HEIGHT:24,
SELECT_SIZE:2,
LARGE_FACE_HEIGHT:48,
LARGE_GROUP_HEIGHT:48,
LARGE_OPTION_HEIGHT:48,
LARGE_SELECT_SIZE:7,
FIELD_HEIGHT:48
}
export default data